import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
import { theme } from "./theme";

// 위에서 받은 `normalize`로 기본 css가 초기화 합니다.
const GlobalStyle = createGlobalStyle`
@import url('https://cdn.rawgit.com/innks/NanumSquareRound/master/nanumsquareround.min.css');

html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,font,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,button{border:0;font-size:100%;vertical-align:baseline;background:transparent;margin:0;padding:0;font-style:normal;font-family:'NanumSquareRound','Noto Sans KR', 'nanum gothic','malgun gothic','Sans-serif';}
body{line-height:1;font-family:'NanumSquareRound','Noto Sans KR', 'nanum gothic','malgun gothic','Sans-serif'; -webkit-font-smoothing: subpixel-antialiased;-webkit-text-stroke:1px transparent;}
ol,ul{list-style:none}
li{list-style:none;}
section, article, aside, hgroup, header, footer, nav, figure, figcaption, summary {display:block;}
address,caption,cite,code,dfn,em,th,var{font-style:normal;font-weight:normal;}
table {border-collapse:collapse; border-spacing:0;}
textarea {resize:none;}
em{font-style:normal;}
a {text-decoration: none}
a:hover{text-decoration:none!important;}
label {cursor:pointer; }
input,textarea{margin:0; vertical-align:bottom;overflow:visible;}
html {overflow-y: scroll;-webkit-text-size-adjust:none;overflow-x:hidden;}
i {color: inherit;}

img {vertical-align: middle;max-width: 100%;height: auto;}

.cf:before,
.cf:after {
    content: " "; /* 1 */
    display: table; /* 2 */
}

.cf:after {
    clear: both;
}

button {
	cursor: pointer;
}


* {
  box-sizing: border-box;
}

html {
  font-size: 16px;
}

@media screen and (max-width: ${theme.breakpoints.sm}) {
  html {
    font-size: 12px;
  }
}

.chakra-radio__control,
.chakra-checkbox__control {
  background-color: #ccc;
}

`;

export default GlobalStyle;
